export default __webpack_public_path__ + "static/Refrigeration_3-8dab792fce146ceedadfb07b58996901.jpg";